import * as React from 'react';
import { styled } from '@mui/material/styles';
import { ImageLoadingSkeleton } from '../../../shared/imageCard/view/ImageLoadingSkeleton';

const ImageContainer = styled('figure')({
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    overflow: 'hidden',
    padding: '16px'
});

const PreviewImage = styled('img')<{ loaded: boolean }>(({ loaded }) => ({
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
    display: 'block',
    opacity: loaded ? 1 : 0,
    transition: 'opacity 200ms ease-in'
}));

const PreviewSkeletonContainer = styled('div')({
    width: '80%',
    height: '70%',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    overflow: 'hidden'
});

type PreviewImageDisplayProps = {
    src: string;
    alt: string;
};

export function PreviewImageDisplay({ src, alt }: PreviewImageDisplayProps) {
    let [imageLoaded, setImageLoaded] = React.useState(false);
    let showSkeleton = !src || !imageLoaded;

    return (
        <ImageContainer>
            {showSkeleton ? (
                <PreviewSkeletonContainer>
                    <ImageLoadingSkeleton />
                </PreviewSkeletonContainer>
            ) : null}
            {src ? (
                <PreviewImage
                    src={src}
                    alt={alt}
                    loaded={imageLoaded}
                    onLoad={() => setImageLoaded(true)}
                    style={
                        showSkeleton
                            ? { position: 'absolute', visibility: 'hidden' }
                            : undefined
                    }
                />
            ) : null}
        </ImageContainer>
    );
}
